export default __webpack_public_path__ + "static/media/analyctic.04cc1f88.png";